import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { notInside, inside } from '../data/content';
export function NotInside() {
  return <section className="bg-ink px-4 py-16 sm:py-24" data-id="element-227" data-mp="17ain1qz1vts7">
      <div className="mx-auto max-w-3xl" data-id="element-228" data-mp="1c9lol1ftnhvf">
        <SectionHeading dark eyebrow="What you won’t find inside" title={<>Not another <em className="text-gold-light" data-id="element-230" data-mp="fjujk89wmcbd">massive video course.</em></>} data-id="element-229" data-mp="1c8k4y8kqpn23" />

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-231" data-mp="jjwmslvafdsr">
          <div className="rounded-3xl bg-coal p-6 ring-1 ring-white/10" data-id="element-232" data-mp="jibtezkpm0wh">
            <p className="text-sm font-black uppercase tracking-wider text-white/50" data-id="element-233" data-mp="oips3r0f7yhu">You won’t need</p>
            <ul className="mt-4 space-y-3" data-id="element-234" data-mp="tbsm209419yk">
              {notInside.map(item => <li key={item} className="flex gap-3" data-id="element-235" data-mp="3rzgcxc0nwg3l">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-400" strokeWidth={3} aria-hidden="true" data-id="element-236" data-mp="tx1ma2kiium" />
                  <span className="text-[17px] text-white/70 line-through decoration-white/30" data-id="element-237" data-mp="12hszh0kyyahb">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="rounded-3xl bg-gold p-6" data-id="element-238" data-mp="yitph1kdrnj0">
            <p className="text-sm font-black uppercase tracking-wider text-ink/60" data-id="element-239" data-mp="topiwjf11hig">Instead, you’ll get</p>
            <ul className="mt-4 space-y-3" data-id="element-240" data-mp="opv0hikz1uyv">
              {inside.map(item => <li key={item} className="flex gap-3" data-id="element-241" data-mp="jsmet80m78sv">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-ink" strokeWidth={3} aria-hidden="true" data-id="element-242" data-mp="jp71oaqi49u3" />
                  <span className="text-[17px] font-bold text-ink" data-id="element-243" data-mp="aqljwhsusyud">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
        <p className="mt-8 text-center text-lg text-white/75" data-id="element-244" data-mp="5tmrq4sr31yt">The things you can actually put to work.</p>

        <SectionCta dark label="Give me the practical tools" data-id="element-245" data-mp="252tl2cvrqbyl" />
      </div>
    </section>;
}